export default __webpack_public_path__ + "static/media/chi7.7a4de4c9.jpg";